import { formatCurrency } from '~libs/dataUtils';
import { Column, Row } from '~components/table-view-v3';

import BatchClientPaymentStatusCell from '~direct-debits/components/payment-batches/BatchClientPaymentStatusCell';
import BatchClientRowAction from '~direct-debits/components/payment-batches/BatchClientRowAction';
import { PaymentBatchClient } from '~direct-debits/models';

export interface BatchDetailCallbacks {
  onViewInvoices?: (clientId: number) => void;
}

export const columnsFactory = (callbacks: BatchDetailCallbacks = {}): Column[] => [
  {
    id: 'client_name',
    header: 'Client Name',
    type: 'text',
    deriveValue: (row) => (row.client_name as string) || '—',
  },
  {
    id: 'payment_status',
    header: 'Payment Status',
    type: 'custom',
    component: BatchClientPaymentStatusCell,
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'amount',
    header: 'Amount',
    type: 'text',
    deriveValue: (row) => formatCurrency(row.amount as string),
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
  {
    id: 'invoice_count',
    header: 'Invoices',
    type: 'text',
    deriveValue: (row) => String(row.invoice_count ?? 0),
    classNames: { header: 'cell-align-center', column: 'cell-align-center' },
  },
  {
    id: 'actions',
    header: '',
    type: 'custom',
    component: BatchClientRowAction,
    componentProps: callbacks,
    classNames: { header: 'cell-align-right', column: 'cell-align-right' },
  },
];

export type BatchClientRow = Row & PaymentBatchClient;
